export const NON_CURRENT_GROUP_LABEL = "SY 25-26 Classes";

// Display name for a class in the pickers. A class that is NOT in the current
// school year is shown prefixed with its school year nickname ("SY25-26: Class 1")
// so past classes are self-labelling; current-year classes show their bare name.
// Purely a display concern — the stored class name is never changed. If the name
// already carries the prefix, it is not duplicated.
export const classDisplayName = (cls) => {
  const name = cls?.name ?? cls?.label ?? "";
  const sy = cls?.school_year;
  if (!sy || sy.is_current === true || !sy.nickname) return name;
  const prefix = `${sy.nickname}: `;
  return name.startsWith(prefix) ? name : `${prefix}${name}`;
};

// Partitions a class list into current-year classes (rendered first, in their
// existing order) and non-current-year classes (everything else, including
// classes whose school_year is null). Grouping keys off the nested school_year
// record supplied by the backend (Feature #32), never the class name.
// Called only for class pickers (SelectDropdown with groupBySchoolYear). Splits
// classes into: current-year (and no-year, e.g. Ednition-synced) rendered inline
// at the top, and past-school-year classes grouped under a collapsible
// "SY 25-26 Classes" header at the bottom. A class with no school_year is treated
// as current (inline), never hidden in the group.
// A class belongs to the current school year when the backend says so, or when it
// carries no school_year at all (e.g. Ednition-synced) — those are never treated as
// past. Shared with the copy picker so "current" means the same thing in both.
export const isCurrentSchoolYear = (cls) =>
  cls?.school_year == null || cls.school_year.is_current === true;

export const groupClassesBySchoolYear = (classes = []) => {
  // Pinned rows (e.g. the "All Classes" null sentinel on SessionHistoryFilters)
  // always render first and are never grouped.
  const pinned = classes.filter((cls) => cls.pinned === true);
  const groupable = classes.filter((cls) => cls.pinned !== true);
  const inline = groupable.filter(isCurrentSchoolYear);
  const nonCurrent = groupable.filter((cls) => !isCurrentSchoolYear(cls));

  const rows = [
    ...pinned.map((cls) => ({ type: "class", class: cls })),
    ...inline.map((cls) => ({ type: "class", class: cls })),
  ];

  if (nonCurrent.length > 0) {
    rows.push({ type: "header", label: NON_CURRENT_GROUP_LABEL, isVisible: false });
    for (const cls of nonCurrent) rows.push({ type: "class", class: cls });
  }
  return rows;
};
